var FormSlide = /** @class */ (function () {
    function FormSlide(element) {
        var style = element.style;
        this.visible = style.display != "none";
        this.slide_number = parseInt(element.getAttribute("data-slide"));
        this.slide = element;
        this.fields = element.getElementsByTagName("input");
    }
    return FormSlide;
}());
export { FormSlide };
var FormConfig = /** @class */ (function () {
    function FormConfig(element) {
        this.form = element;
        this.form_name = element.name;
        this.method = element.method;
        this.id = element.id;
        if (element.getElementsByClassName("form-slider-pagination").length > 0) {
            var p = element.getElementsByClassName("form-slider-pagination")[0];
            if (p instanceof HTMLOListElement || p instanceof HTMLUListElement) {
                this.pagination = p;
            }
            this.pagination = element.getElementsByClassName("form-slider-pagination")[0];
        }
        if (element.getElementsByClassName("formslider-holder").length == 0)
            return;
        this.slideHolder = new SlideHolder(element.getElementsByClassName("formslider-holder")[0]);
    }
    FormConfig.prototype.Config = function () {
        // console.log("test");
    };
    return FormConfig;
}());
export { FormConfig };
var SlideHolder = /** @class */ (function () {
    function SlideHolder(element) {
        this.slides = [];
        this.holder = element;
        var slides = element.getElementsByClassName("form-slide");
        for (var i = 0; i < slides.length; i++) {
            this.slides.push(new FormSlide(slides[i]));
        }
    }
    return SlideHolder;
}());
export { SlideHolder };
var MultiScreenSlideForm = /** @class */ (function () {
    function MultiScreenSlideForm(element, nextButton, prevButton, submitButton) {
        this.formconfig = element;
        this.nextButton = nextButton;
        this.prevButton = prevButton;
        this.submitButton = submitButton;
        this.InitializeSlides();
    }
    MultiScreenSlideForm.prototype.InitializeSlides = function () {
        var $this = this;
        this.nextButton.addEventListener("click", function (e) {
            var s = $this.getActiveSlide();
            for (var i = 0; i < s.fields.length; i++) {
                var field_status = s.fields[i].checkValidity();
                // console.log(s.fields![i]);
                // console.log(field_status);
                if (!field_status) {
                    s.fields[i].reportValidity();
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
            }
            $this.nextSlide();
            e.preventDefault();
        });
        this.prevButton.addEventListener("click", function () {
            $this.previousSlide();
        });
        var slides = this.formconfig.slideHolder.slides;
        slides.forEach(function (slide) {
            slide.visible = false;
            slide.slide.classList.add("d-none");
        });
        this.slideFadeIn(slides[0]);
        var slideButtons = document.querySelectorAll('.form-slider-pagination .page-link');
        slideButtons.forEach(function (c) {
            c.addEventListener("click", function (e) {
                e.preventDefault();
                $this.setSlide(parseInt(c.querySelectorAll('i')[0].innerText) - 1);
            });
        });
    };
    MultiScreenSlideForm.prototype.getActiveSlide = function () {
        var slide = this.formconfig.slideHolder.slides.filter(function (fs) { return fs.visible == true; });
        if (slide == null)
            return null;
        if (slide.length != 1)
            return null;
        return slide[0];
    };
    MultiScreenSlideForm.prototype.getSlideCount = function () {
        return this.formconfig.slideHolder.slides.length;
    };
    MultiScreenSlideForm.prototype.getSlide = function (slideNumber) {
        return this.formconfig.slideHolder.slides[slideNumber];
    };
    MultiScreenSlideForm.prototype.slideFadeIn = function (element) {
        // console.log("Start FadeIn");
        // console.log(element);
        element.slide.classList.remove("d-none");
        var animation = element.slide.animate({ opacity: 1 }, { duration: 1000, fill: 'forwards' });
        animation.addEventListener("finish", function (e) {
        });
        animation.play();
        element.visible = true;
    };
    MultiScreenSlideForm.prototype.slideFadeOut = function (element) {
        element.visible = false;
        element.slide.style.position = "absolute";
        element.slide.style.top = "0";
        var animation = element.slide.animate({ opacity: 0 }, { duration: 400, fill: "forwards" });
        animation.addEventListener("finish", function (e) {
            element.slide.style.position = "inherit";
            element.slide.classList.add("d-none");
        });
        animation.play();
    };
    MultiScreenSlideForm.prototype.nextSlide = function () {
        // console.log(this);
        var active_slide = this.getActiveSlide();
        var max_slides = this.getSlideCount();
        // console.log("NEXTSLIDE");
        // console.log(this.formconfig.slideHolder.slides.indexOf(active_slide));
        // console.log(max_slides);
        if ((this.formconfig.slideHolder.slides.indexOf(active_slide)) == (max_slides - 2)) {
            this.nextButton.classList.add("d-none");
            this.submitButton.classList.remove("d-none");
        }
        else if ((this.formconfig.slideHolder.slides.indexOf(active_slide)) == max_slides - 1) {
            return;
        }
        else if (this.formconfig.slideHolder.slides.indexOf(active_slide) == 0) {
            this.prevButton.classList.remove("d-none");
        }
        if (this.formconfig.pagination !== undefined) {
            this.nextPagination(this.formconfig.pagination);
        }
        this.setSlide((this.formconfig.slideHolder.slides.indexOf(active_slide)) + 1);
    };
    MultiScreenSlideForm.prototype.previousSlide = function () {
        var active_slide = this.getActiveSlide();
        var max_slides = this.getSlideCount();
        // console.log('PREVIOUSSLIDE');
        // console.log(this.formconfig.slideHolder.slides.indexOf(active_slide));
        if ((this.formconfig.slideHolder.slides.indexOf(active_slide)) == 1) {
            this.prevButton.classList.add("d-none");
        }
        else if ((this.formconfig.slideHolder.slides.indexOf(active_slide)) == 0) {
            return;
        }
        else if ((this.formconfig.slideHolder.slides.indexOf(active_slide)) == (max_slides - 1)) {
            this.nextButton.classList.remove("d-none");
            this.submitButton.classList.add("d-none");
        }
        if (this.formconfig.pagination !== undefined) {
            this.prevPagination(this.formconfig.pagination);
        }
        this.setSlide((this.formconfig.slideHolder.slides.indexOf(active_slide)) - 1);
    };
    MultiScreenSlideForm.prototype.setSlide = function (slideNumber) {
        var slide = this.formconfig.slideHolder.slides[slideNumber];
        var $this = this;
        this.formconfig.slideHolder.slides.forEach(function (s) {
            if (s.visible == true) {
                $this.slideFadeOut(s);
            }
        });
        this.slideFadeIn(slide);
    };
    MultiScreenSlideForm.prototype.nextPagination = function (paginationElement) {
        var activeItem = paginationElement.getElementsByClassName("page-item active")[0];
        var newActiveItem = activeItem.nextElementSibling;
        if (newActiveItem == null) {
            return;
        }
        activeItem.classList.remove("active");
        newActiveItem.classList.add("active");
    };
    MultiScreenSlideForm.prototype.prevPagination = function (paginationElement) {
        var activeItem = paginationElement.getElementsByClassName("page-item active")[0];
        var newActiveItem = activeItem.previousElementSibling;
        if (newActiveItem == null) {
            return;
        }
        activeItem.classList.remove("active");
        newActiveItem.classList.add("active");
    };
    return MultiScreenSlideForm;
}());
export { MultiScreenSlideForm };
